import { render, staticRenderFns } from "./Katalog.vue?vue&type=template&id=345f3fd5&scoped=true"
import script from "./Katalog.vue?vue&type=script&lang=js"
export * from "./Katalog.vue?vue&type=script&lang=js"
import style0 from "./Katalog.vue?vue&type=style&index=0&id=345f3fd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f3fd5",
  null
  
)

export default component.exports